<nav class="navbar" [ngClass]="{ 'navbar-questionnaire': isDarkNavbar }">
  <div class="navbar-container">
    <div class="brand-logo" (click)="navigateToLogoLink()" [ngClass]="{ 'clickable': logoLink }">
      <img [src]="isDarkNavbar ? 'logo.png' : 'logo_black.png'" alt="Logo" class="logo" />
    </div>

    <div class="navbar-right" *ngIf="isLoggedIn">
      <div class="navbar-language-switcher" *ngIf="showLanguageSwitcher">
        <button
          type="button"
          class="btn preferred-language-button"
          [disabled]="isSavingLocale"
          [attr.aria-label]="'Switch questionnaire language to ' + nextLocale.toUpperCase()"
          (click)="confirmLanguageChange(nextLocale)"
        >
          <span
            *ngIf="isSavingLocale"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          {{ languageSwitcherLabel }}: <span>{{ selectedLanguageCode }}</span>
        </button>
      </div>

      <div class="user-profile" (click)="toggleDropdown()" tabindex="0">
        <img *ngIf="userImage" [src]="userImage" alt="User Avatar" class="user-avatar" />
        <img *ngIf="!userImage && !getInitials()" [src]="'default_avatar.svg'" alt="Default Avatar" class="user-avatar" />
        <div *ngIf="!userImage && getInitials()" class="user-initials">
          {{ getInitials() }}
        </div>
      </div>

      <div class="dropdown" [ngClass]="{ 'dropdown-dark': isDarkNavbar }" *ngIf="showDropdown">
        <div class="dropdown-header">
          <div class="dropdown-info">
            <p *ngIf="userName" class="user-name">Hi, {{ userName }}!</p>
            <img *ngIf="userImage" [src]="userImage" alt="User Avatar" class="dropdown-avatar" />
            <img *ngIf="!userImage && !getInitials()" [src]="'default_avatar.svg'" alt="Default Avatar" class="dropdown-avatar" />
            <div *ngIf="!userImage && getInitials()" class="dropdown-avatar initials">
              {{ getInitials() }}
            </div>
            <p class="user-info">{{ userEmail }}</p>
            <p class="user-info">{{ userRole }}</p>
          </div>
        </div>
        <div class="dropdown-actions">
          <button class="dropdown-button" (click)="onLogout()">Sign out</button>
        </div>
      </div>
    </div>
  </div>
</nav>
